module.exports = __webpack_public_path__ + "media/alaska/denali-21824342.jpg";